exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tag-item{margin:2px;padding:0 5px;display:inline-block;float:left;font:14px Helvetica Neue,Helvetica,Arial,sans-serif;height:26px;line-height:25px;border:1px solid #acacac;border-radius:3px;background:linear-gradient(180deg,#f0f9ff 0,#cbebff 47%,#a1dbff)}.tagitemdisabled{pointer-events:none;background:#337ab7;opacity:.65}.tag-invisible{display:none}.tag-input input{border:none;width:100%!important}.remove-button{text-decoration:none;font-size:20px;padding-left:5px;color:#f0f9ff}.remove-button:hover{text-decoration:none;color:#d9534f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/tipos-atributo-cliente/form/form.scss
// module id = 1055
// module chunks = 0